module.exports = __webpack_public_path__ + "components/MapControl/svg/Źródło.svg?7117ac82";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Źródło.svg
// module id = 2057
// module chunks = 0